import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useConfirmStore } from '@/stores/confirm-store'

/** Mounted once at the root; renders whatever `confirmAction` requests. */
export function ConfirmDialogHost() {
  const request = useConfirmStore((state) => state.request)
  const settle = useConfirmStore((state) => state.settle)

  return (
    <Dialog
      open={Boolean(request)}
      onOpenChange={(open) => {
        if (!open) settle(false)
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{request?.title}</DialogTitle>
          {request?.description ? (
            <DialogDescription>{request.description}</DialogDescription>
          ) : null}
        </DialogHeader>

        <DialogFooter>
          <Button variant="outline" onClick={() => settle(false)}>
            {request?.cancelLabel ?? 'Cancelar'}
          </Button>
          <Button
            variant={request?.destructive ? 'destructive' : 'default'}
            onClick={() => settle(true)}
          >
            {request?.confirmLabel ?? 'Confirmar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
